import { AxiosClient } from "./AxiosClient";

export const getGeneral = () => {
  try {
    return AxiosClient.get("team/getGeneral");
  } catch (e) {
    console.log(e);
  }
};

export const getConversations = () => {
  try {
    return AxiosClient.get("team/getConversations");
  } catch (e) {
    console.log(e);
  }
};

export const getOrCreateDM = (target_uuid) => {
  try {
    return AxiosClient.post("team/getOrCreateDM", { target_uuid });
  } catch (e) {
    console.log(e);
  }
};

export const createGroup = (name, member_uuids) => {
  try {
    return AxiosClient.post("team/createGroup", { name, member_uuids });
  } catch (e) {
    console.log(e);
  }
};

export const getTeamMessages = (team_id, before = null, limit = 50) => {
  try {
    let url = "team/getMessages?team_id=" + team_id + "&limit=" + limit;
    if (before) url += "&before=" + before;
    return AxiosClient.get(url);
  } catch (e) {
    console.log(e);
  }
};

export const getTeamMembers = (team_id) => {
  try {
    return AxiosClient.get("team/getMembers?team_id=" + team_id);
  } catch (e) {
    console.log(e);
  }
};

export const addTeamMembers = (team_id, member_uuids) => {
  try {
    return AxiosClient.post("team/addMembers", { team_id, member_uuids });
  } catch (e) {
    console.log(e);
  }
};

export const leaveGroup = (team_id) => {
  try {
    return AxiosClient.post("team/leaveGroup", { team_id });
  } catch (e) {
    console.log(e);
  }
};

export const searchTeamUsers = (q, exclude_team_id = "") => {
  try {
    let url = "team/searchUsers?q=" + encodeURIComponent(q);
    if (exclude_team_id) url += "&exclude_team_id=" + exclude_team_id;
    return AxiosClient.get(url);
  } catch (e) {
    console.log(e);
  }
};

export const getPinnedMessages = (team_id) => {
  try {
    return AxiosClient.get("team/getPinnedMessages?team_id=" + team_id);
  } catch (e) {
    console.log(e);
  }
};

export const searchMessages = (q, team_id = "") => {
  try {
    let url = "team/searchMessages?q=" + encodeURIComponent(q);
    if (team_id) url += "&team_id=" + team_id;
    return AxiosClient.get(url);
  } catch (e) {
    console.log(e);
  }
};

export const getEmojiFrequency = () => {
  try {
    return AxiosClient.get("team/getEmojiFrequency");
  } catch (e) {
    console.log(e);
  }
};

export const getAvatarSettings = () => {
  try {
    return AxiosClient.get("team/getAvatarSettings");
  } catch (e) {
    console.log(e);
  }
};

export const updateAvatarSettings = (
  avatar_mode,
  avatar_color,
  avatar_url = "",
) => {
  try {
    return AxiosClient.post("team/updateAvatarSettings", {
      avatar_mode,
      avatar_color,
      avatar_url,
    });
  } catch (e) {
    console.log(e);
  }
};

export const getAvatarsBulk = (uuids) => {
  try {
    return AxiosClient.post("team/getAvatarsBulk", { uuids });
  } catch (e) {
    console.log(e);
  }
};

export const getNotificationPrefs = () => {
  try {
    return AxiosClient.get("team/getNotificationPrefs");
  } catch (e) {
    console.log(e);
  }
};

export const muteConversation = (team_id, muted) => {
  try {
    return AxiosClient.post("team/muteConversation", { team_id, muted });
  } catch (e) {
    console.log(e);
  }
};

export const archiveConversation = (team_id, archived) => {
  try {
    return AxiosClient.post("team/archiveConversation", { team_id, archived });
  } catch (e) {
    console.log(e);
  }
};

export const getArchivedConversations = () => {
  try {
    return AxiosClient.get("team/getArchivedConversations");
  } catch (e) {
    console.log(e);
  }
};

export const uploadTeamFiles = (team_id, files) => {
  try {
    const formData = new FormData();
    formData.append("team_id", team_id);
    for (const file of files) {
      formData.append("files", file);
    }
    return AxiosClient.post("team/uploadFile", formData);
  } catch (e) {
    console.log(e);
  }
};

export const getFileUrl = (team_id, s3_key) => {
  try {
    return AxiosClient.get("team/getFileUrl", { params: { team_id, s3_key } });
  } catch (e) {
    console.log(e);
  }
};
